// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"546262c1","165":"cc9af0a8","453":"999976e0","563":"9f64226a"}[chunkId] + ".chunk.js";
};